import React, { useState } from 'react'
import { useMutation, useQuery } from 'react-apollo'

import { getGQLErrorMsg } from '../../../../lib/apollo'
import { CardWrapper, CardContent } from '../../../shared/settings/card'
import Checkbox from '../../../forms/checkbox'

import ACCOUNT_QUERY_WITH_DIR from '../../../../../graphql/queries/account-with-directives.gql'
import ACCOUNT_MUTATION from '../../../../../graphql/mutations/account.gql'

import styles from './opt-ins.css'

const ACCOUNT_OPT_INS_QUERY_VARIABLES = {
  withOptIns: true,
  withClearCachedSubscriptions: true
}

export default function OptIns() {
  const [error, setError] = useState('')
  const {
    loading: accountQueryLoading,
    data: accountQueryData,
    error: accountQueryError
  } = useQuery(ACCOUNT_QUERY_WITH_DIR, {
    fetchPolicy: 'network-only',
    variables: ACCOUNT_OPT_INS_QUERY_VARIABLES
  })
  const [updateAccount] = useMutation(ACCOUNT_MUTATION)

  if (accountQueryLoading || accountQueryError) {
    return null
  }

  const changeOptIn = (evt, optIn, subscribed) => {
    updateAccount({
      variables: {
        input: {
          optIns: [{ id: optIn.id, subscribed }]
        }
      },
      optimisticResponse: {
        __typename: 'Mutation',
        account: {
          __typename: 'Account',
          optIns: [
            {
              __typename: 'AccountOptIn',
              id: optIn.id,
              subscribed
            }
          ]
        }
      },
      update: (proxy, response) => {
        const data = proxy.readQuery({
          query: ACCOUNT_QUERY_WITH_DIR,
          variables: ACCOUNT_OPT_INS_QUERY_VARIABLES
        })
        const updatedOptIn = response.data.account.optIns[0]
        if (!updatedOptIn) return

        proxy.writeQuery({
          query: ACCOUNT_QUERY_WITH_DIR,
          variables: ACCOUNT_OPT_INS_QUERY_VARIABLES,
          data: {
            ...data,
            account: {
              ...data.account,
              optIns: data.account.optIns.map(currentOptIn => (
                currentOptIn.id === updatedOptIn.id ? updatedOptIn : currentOptIn
              ))
            }
          }
        })
      }
    }).catch(mutationError => {
      setError(getGQLErrorMsg(mutationError))
    })
  }

  const optIns = accountQueryData?.account?.optIns || []

  if (!optIns.length) {
    return null
  }

  const inputs = optIns.map((optIn) => {
    return (
      <Checkbox
        className={styles.checkbox}
        labelClassName={styles.labelText}
        key={optIn.id}
        id={optIn.id}
        isChecked={optIn.subscribed}
        label={optIn.text}
        onChange={changeOptIn}
        value={optIn}
      />
    )
  })

  return (
    <CardWrapper>
      <CardContent className={styles.cardContent}>
        {inputs}
        {error && <div className={styles.warningMessage}>{error}</div>}
      </CardContent>
    </CardWrapper>
  )
}
